import { memo, useEffect, useMemo } from 'react';
import { formatBytes } from 'react-dropzone-uploader';
import { ListGroup, ListGroupItem, Progress } from 'shards-react';
import Loading from 'components/Loading';

const DropzonePreview = ({ meta: { name = '', percent = 0, size = 0, status }, fileWithMeta: { remove, restart }, isSubmitted, serviceType, setUploadDocumentOpen, triggerListChange }) => {
	const fileSize = useMemo(() => formatBytes(size), [size]);
	const isUploading = useMemo(() => status === 'uploading', [status]);
	const uploadSuccessful = useMemo(() => ['headers_received', 'done'].includes(status), [status]);
	const uploadFailed = useMemo(() => ['error_upload_params', 'exception_upload', 'error_upload', 'aborted'].includes(status), [status]);

	const statusMessage = useMemo(() => {
		if (isUploading) {
			return (
				<span>
					<i className='fas fa-file-upload text-success mx-2' />
					Dokument wird hochgeladen!
				</span>
			);
		}
		if (uploadFailed) {
			return (
				<span>
					<i className='fas fa-times-circle text-danger mx-2' />
					Hochladen fehlgeschlagen!
				</span>
			);
		}
	}, [isUploading, uploadFailed]);

	useEffect(() => {
		let timeOut;

		// Seiten-Reload nur bei erfolgreichem Upload und nach Submit-Klick
		if (uploadSuccessful && isSubmitted) {
				setUploadDocumentOpen(false);
				triggerListChange()
		}

	}, [uploadSuccessful, isSubmitted]);

	if (status === 'preparing') return <Loading classes='my-auto' />;

	if (uploadSuccessful) {
		return (
			<div className='my-auto text-success'>
				<i className={isSubmitted ? 'fas fa-check-circle mr-2' : ''} />
				{isSubmitted ? `${name} hochgeladen!` : null}
			</div>
		);
	}

	return (
		<ListGroup className='w-100'>
			<ListGroupItem>
				<strong>Dateiname: </strong>
				{name}
			</ListGroupItem>
			<ListGroupItem>
				<strong>Dateigröße: </strong>
				{fileSize}
			</ListGroupItem>
			<ListGroupItem>
				<strong>Status: </strong>
				{statusMessage}
			</ListGroupItem>
			<ListGroupItem className='d-flex align-items-center'>
				<strong>Fortschritt: </strong>
				<Progress theme='warning' tag='span' className='ml-2 w-50' max='100' value={percent} />
				{uploadFailed && <i className='fas fa-redo ml-3 pointer text-success' title='Versuchen Sie es noch einmal!' onClick={restart} />}
				<i className='fas fa-times ml-3 pointer text-danger' title='Datei entfernen!' onClick={remove} />
			</ListGroupItem>
		</ListGroup>
	);
};

export default memo(DropzonePreview);
